export default __webpack_public_path__ + "static/media/AudioMasterCan.a32527b6.png";